// src/apis/pageAPI.js

import { api } from "./configs/axiosConfigs";
import { defineCancelApiObject } from "./configs/axiosUtils";

export const AuthAPI = {
  login: async function (data, cancel = false) {
    const response = await api.request({
      url: `/auth/login`,
      method: "POST",
      data: data,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.login.name].handleRequestCancellation().signal
        : undefined,
    });

    // returning the page returned by the API
    return response;
  },

  getUserProfile: async function (cancel = false) {
    try {
      const response = await api.request({
        url: `/auth/GetUserProfile`,
        method: "GET",

        // retrieving the signal value by using the property name
        signal: cancel
          ? cancelApiObject[
              this.getUserProfile.name
            ].handleRequestCancellation().signal
          : undefined,
      });

      // returning the page returned by the API
      return response;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.warn("Usuario no autorizado (401)");

        return null; // o lo que necesites
      }

      // Si no es un 401, relanzás el error
      throw error;
    }
  },

  getPaginated: async function (
    { page, perPage, sortColumn, sortDirection, query, filters },
    cancel = false
  ) {
    var params = {
      page: page,
      per_page: perPage,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      query: query,
    };

    // Object.assign(params, filters);

    const response = await api.request({
      url: "/auth/GetUserOrders",
      method: "GET",
      params: params,
      signal: cancel
        ? cancelApiObject[this.getPaginated.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    return response;
  },

  registerSmall: async function (data, cancel = false) {
    const response = await api.request({
      url: `/auth/RegisterSmall`,
      method: "POST",
      data: data,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.registerSmall.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the page returned by the API
    return response;
  },

 changePassword: async function (data, cancel = false) {
    const response = await api.request({
      url: `/auth/changePassword`,
      method: "POST",
      data: data,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.changePassword.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the page returned by the API
    return response;
  },

  generateRecoveryLink: async function (data, cancel = false) {
    const response = await api.request({
      url: `/auth/GenerateRecoveryLink`,
      method: "POST",
      data: data,
      // retrieving the signal value by using the property name
      signal: cancel
        ? cancelApiObject[this.generateRecoveryLink.name].handleRequestCancellation()
            .signal
        : undefined,
    });

    // returning the page returned by the API
    return response;
  },


 isLinkOk: async function (data, cancel = false) {
  try {
    const response = await api.request({
      url: `/auth/isLinkOk/${data}`,
      method: "GET",
      signal: cancel
        ? cancelApiObject[
            this.getUserProfile.name
          ].handleRequestCancellation().signal
        : undefined,
    });

    return { success: true, data: response.data };

  } catch (error) {
    // Si querés loguearlo internamente pero no romper la UI
    console.error("Error en isLinkOk:", error?.response?.status, error?.message);

    return { 
      success: false, 
      status: error?.response?.status || null, 
      message: error?.response?.data?.message || "Error al verificar link" 
    };
  }
}
};

const cancelApiObject = defineCancelApiObject(AuthAPI);
